/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemSettingResponseDtoValue } from './SystemSettingResponseDtoValue';
import {
    SystemSettingResponseDtoValueFromJSON,
    SystemSettingResponseDtoValueFromJSONTyped,
    SystemSettingResponseDtoValueToJSON,
    SystemSettingResponseDtoValueToJSONTyped,
} from './SystemSettingResponseDtoValue';

/**
 * 
 * @export
 * @interface SystemSettingResponseDto
 */
export interface SystemSettingResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SystemSettingResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SystemSettingResponseDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof SystemSettingResponseDto
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof SystemSettingResponseDto
     */
    valueType: SystemSettingResponseDtoValueTypeEnum;
    /**
     * 
     * @type {SystemSettingResponseDtoValue}
     * @memberof SystemSettingResponseDto
     */
    value: SystemSettingResponseDtoValue;
    /**
     * 
     * @type {SystemSettingResponseDtoValue}
     * @memberof SystemSettingResponseDto
     */
    defaultValue: SystemSettingResponseDtoValue;
    /**
     * 
     * @type {object}
     * @memberof SystemSettingResponseDto
     */
    constraints?: object;
    /**
     * 
     * @type {string}
     * @memberof SystemSettingResponseDto
     */
    unit?: string;
    /**
     * Allowed values, only for ENUM settings
     * @type {Array<string>}
     * @memberof SystemSettingResponseDto
     */
    options?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SystemSettingResponseDto
     */
    editable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SystemSettingResponseDto
     */
    requiresRestart: boolean;
    /**
     * 
     * @type {string}
     * @memberof SystemSettingResponseDto
     */
    classification: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemSettingResponseDto
     */
    consumers: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SystemSettingResponseDto
     */
    sortOrder: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSettingResponseDto
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof SystemSettingResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SystemSettingResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const SystemSettingResponseDtoValueTypeEnum = {
    Boolean: 'BOOLEAN',
    Number: 'NUMBER',
    Cron: 'CRON',
    Timezone: 'TIMEZONE',
    DurationMs: 'DURATION_MS',
    Enum: 'ENUM'
} as const;
export type SystemSettingResponseDtoValueTypeEnum = typeof SystemSettingResponseDtoValueTypeEnum[keyof typeof SystemSettingResponseDtoValueTypeEnum];


/**
 * Check if a given object implements the SystemSettingResponseDto interface.
 */
export function instanceOfSystemSettingResponseDto(value: object): value is SystemSettingResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('valueType' in value) || value['valueType'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('defaultValue' in value) || value['defaultValue'] === undefined) return false;
    if (!('editable' in value) || value['editable'] === undefined) return false;
    if (!('requiresRestart' in value) || value['requiresRestart'] === undefined) return false;
    if (!('classification' in value) || value['classification'] === undefined) return false;
    if (!('consumers' in value) || value['consumers'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SystemSettingResponseDtoFromJSON(json: any): SystemSettingResponseDto {
    return SystemSettingResponseDtoFromJSONTyped(json, false);
}

export function SystemSettingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemSettingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'key': json['key'],
        'category': json['category'],
        'valueType': json['valueType'],
        'value': SystemSettingResponseDtoValueFromJSON(json['value']),
        'defaultValue': SystemSettingResponseDtoValueFromJSON(json['defaultValue']),
        'constraints': json['constraints'] == null ? undefined : json['constraints'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'options': json['options'] == null ? undefined : json['options'],
        'editable': json['editable'],
        'requiresRestart': json['requiresRestart'],
        'classification': json['classification'],
        'consumers': json['consumers'],
        'sortOrder': json['sortOrder'],
        'version': json['version'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SystemSettingResponseDtoToJSON(json: any): SystemSettingResponseDto {
    return SystemSettingResponseDtoToJSONTyped(json, false);
}

export function SystemSettingResponseDtoToJSONTyped(value?: SystemSettingResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'key': value['key'],
        'category': value['category'],
        'valueType': value['valueType'],
        'value': SystemSettingResponseDtoValueToJSON(value['value']),
        'defaultValue': SystemSettingResponseDtoValueToJSON(value['defaultValue']),
        'constraints': value['constraints'],
        'unit': value['unit'],
        'options': value['options'],
        'editable': value['editable'],
        'requiresRestart': value['requiresRestart'],
        'classification': value['classification'],
        'consumers': value['consumers'],
        'sortOrder': value['sortOrder'],
        'version': value['version'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

